'use strict';

(function () {
  'use strict';

  angular.module('msWidgets', ['msUtility', 'msCore', 'msTracker', 'angularModalService']).directive('msWidget', msWidgetDirective);

  // Directive
  msWidgetDirective.$inject = ['$compile', '$log'];

  function msWidgetDirective($compile, $log) {
    return {
      restrict: 'AE',
      link: function link(scope, ele) {
        // this property is needed to generate uniq id if several wingets with the sime type is used
        scope.randomInt = Math.floor(Math.random() * 1000001);

        if (!scope.widget.type) {
          $log.error('msWidget type is undefined.');
        } else {
          var directive = scope.widget.type.replace('/', '-').split('_').join('-');

          ele.replaceWith($compile('<ms-widget-' + directive + '></ms-widget-' + directive + '>')(scope));
        }
      },
      controller: msWidgetCtrl
    };
  }

  // Controller
  msWidgetCtrl.$inject = ['$scope', '$timeout', '$filter'];

  function msWidgetCtrl($scope, $timeout, $filter) {
    $scope.showSkipMenu = false;
    for (var prop in $scope.widget.properties) {
      $scope.widget.properties[prop] = $filter('transformEntity')($scope.widget.properties[prop]);
    }

    $scope.getVideoTitle = function (videoPlayerName) {
      // NOSONAR
      var defaultVideoPlayerName = (videoPlayerName ? videoPlayerName + ' ' : '') + 'Video Player';
      var videoTitle = null;

      if ($scope.widget && $scope.widget.properties && $scope.widget.properties.title) {
        videoTitle = $scope.widget.properties.title;
      } else if ($scope.$parent.vm && $scope.$parent.vm.section && $scope.$parent.vm.section.widgets) {
        var headingWidgets = $scope.$parent.vm.section.widgets.filter(function (item) {
          var headingRegex = /copy\/h/i;
          return headingRegex.test(item.type);
        });
        var largestHeadingWidget = headingWidgets.reduce(function (acc, item) {
          var headingReplacementText = 'copy/h';
          var accHeadingNumber = acc.type ? parseInt(acc.type.replace(headingReplacementText)) : null;
          var itemHeadingNumber = item.type ? parseInt(item.type.replace(headingReplacementText)) : null;
          if (!acc.type || itemHeadingNumber > accHeadingNumber) {
            acc = item;
          }
          return acc;
        }, {});

        videoTitle = largestHeadingWidget.properties && largestHeadingWidget.properties.text ? largestHeadingWidget.properties.text : null;
      }

      return videoTitle ? 'Video: ' + videoTitle : defaultVideoPlayerName;
    };

    $scope.toggleSkipMenu = function () {
      $scope.showSkipMenu = !$scope.showSkipMenu;
      if ($scope.showSkipMenu) {
        $timeout(function () {
          document.querySelector('#skip-reasons-menu li:first-child a').focus();
        }, 100);
      }
    };

    $scope.closeSkipMenu = function () {
      $scope.showSkipMenu = false;
    };
  }
})();